import { useUser } from "@features/user"
import type React from "react"
import { Outlet } from "react-router-dom"
import Sidebar from "../../components/Sidebar"
import useEnv from "../../hooks/useEnv"

import NotificationsBell from "@features/notifications/components/NotificationsBell"
import UserMenu from "@features/user/components/UserMenu"
import styles from "./Layout.module.css"

const Layout: React.FC = () => {
  const { data } = useUser()
  const { geconturUrl, logo, company, isGea } = useEnv()

  return (
    <div className={styles.Root}>
      <div className={styles.Main}>
        <a href={geconturUrl}>
          <img
            style={{ width: isGea ? "110px" : "200px" }}
            className={styles.Logo}
            alt={company}
            title={company}
            src={logo}
          />
        </a>

        <div className="flex items-center gap-4 mr-4">
          <NotificationsBell />
          <UserMenu />
        </div>
      </div>
      <div className={styles.Menu}>
        <Sidebar />
      </div>
      <div className={styles.Content}>
        <Outlet />
      </div>
    </div>
  )
}

export default Layout
